import VerifiedOutlined from '@mui/icons-material/VerifiedOutlined';
import { FC } from 'react';
import ToolTipContent from '../ToolTipContent';
interface Props {
  size?: 'sm' | 'md';
}
export const VerifiedCompanyIcon: FC<Props> = ({ size = 'md' }) => {
  const sizeMap = {
    sm: '16px',
    md: '24px'
  };
  return (
    <ToolTipContent tooltip text={'Verified company'}>
      <VerifiedOutlined
        sx={{ color: '#ff6b6b', width: sizeMap[size], height: sizeMap[size] }}
      />
    </ToolTipContent>
  );
};
